import IconArrowLeft from 'assets/icons/arrow-left.svg';
import Container from 'components/container';
import FunnelCta from 'components/funnel/cta';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FUNNEL_STEPS } from '../constants';
import FoodTypeSelector from '../food-type-selector';
import PetTypeSelector from '../pet-type-selector';
import { useSubscriptionFunnel } from '../state';

const StepPreference: React.FC = () => {
  const { goToStep, petType, selectedCategories, isExistingSubscription } = useSubscriptionFunnel();

  return (
    <div className="bg-other-white w-full lg:max-w-2xl lg:rounded-lg lg:shadow-lg">
      <Container>
        <h1 className="text-primary-main flex text-xl leading-6 font-medium lg:pt-4 lg:text-4xl lg:leading-10 lg:font-black">
          {!isExistingSubscription && (
            <button
              className="focus-default mr-4 pt-1 pb-2"
              onClick={() => {
                goToStep(FUNNEL_STEPS.START);
              }}
            >
              <IconArrowLeft className="h-6 w-6" />
            </button>
          )}
          <FormattedMessage id="subscription-funnel:preference:header" />
        </h1>

        <p className="text-text-light-bg-secondary mt-2 lg:mt-4 lg:text-lg">
          <FormattedMessage id="subscription-funnel:preference:sub-header" />
        </p>

        <h2 className="text-primary-main mt-4 text-lg font-black lg:mt-6 lg:text-2xl">
          <FormattedMessage id="subscription-funnel:preference:question-1" />
        </h2>

        <PetTypeSelector />

        <h2 className="text-primary-main mt-4 text-lg font-black lg:mt-6 lg:text-2xl">
          <FormattedMessage id="subscription-funnel:preference:question-2" />
        </h2>
        <div className="text-grey-700 -mt-2 font-medium lg:text-lg">
          <FormattedMessage id="subscription-funnel:preference:selection-info" />
        </div>

        <FoodTypeSelector />

        <FunnelCta
          visible={selectedCategories.length > 0 && petType !== null}
          onClick={() => {
            goToStep(FUNNEL_STEPS.PRODUCTS);
          }}
        >
          <FormattedMessage id="subscription-funnel:button:continue" />
        </FunnelCta>
      </Container>
    </div>
  );
};

export default StepPreference;
